const guideGen1 = [
  "Starte in Alabastia",
  "Route 1 – Gehe nach Vertania City",
  "Route 1 – Zurück nach Alabastia und Pokédex holen",
  "Route 2 & Vertania Wald – Richtung Marmoria City",
  "Marmoria City – 1. Arena (Gestein, Rocko)",
  "Route 3 & Mondberg – Richtung Azuria City",
  "Azuria City – 2. Arena (Wasser, Misty)",
  "Route 24 & 25 – Bill helfen",
  "Route 5 & 6 – Richtung Orania City",
  "Orania City – 3. Arena (Elektro, Major Bob)",
  "MS Anne – Zerschneider erhalten",
  "Digda-Tunnel nach Lavandia",
  "Route 9 & Felstunnel – Nach Lavandia",
  "Route 10 – Kraftwerk (optional)",
  "Lavandia – Turm betreten (später)",
  "Route 8 & 7 – Nach Prismania City",
  "Prismania City – 4. Arena (Pflanze, Erika)",
  "Team Rocket in Game Corner besiegen",
  "Silph Scope holen",
  "Zurück nach Lavandia – Turm abschließen",
  "Route 12/13/14/15 – Richtung Fuchsania City",
  "Fuchsania City – 5. Arena (Gift, Koga)",
  "Safari-Zone – Surfer & Goldzähne finden",
  "Zurück nach Orania – Stärke erhalten",
  "Lavandia – Route 16, 17, 18 – Prismania von hinten",
  "Prismania City – Radweg & Route 17",
  "Saffronia City – Silph Co. retten",
  "Saffronia City – 6. Arena (Psycho, Sabrina)",
  "Zinnoberinsel – Pokémon Mansion Schlüssel finden",
  "Zinnoberinsel – 7. Arena (Feuer, Pyro)",
  "Route 20 – Seeschauminseln (optional)",
  "Route 21 – Zurück nach Alabastia",
  "Vertania City – 8. Arena (Giovanni, Boden)",
  "Route 22 – Rivalen-Kampf",
  "Siegesstraße – Durchqueren",
  "Pokémon-Liga – Top 4 & Champ besiegen",
];

export default guideGen1;
